// @flow
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { CONTENT_NOT_FOUND } from "../../../../locales/components/namespaces";

type Props = {
	displayContent: boolean
};

const ContentNotFound = (props: Props) => {
	const { displayContent, children, message } = props
	const { t } = useTranslation(CONTENT_NOT_FOUND)
	return !Boolean(displayContent) ? (
		<Box>
			<Typography
				variant={'subtitle2'}
				component={'div'}
				p={0.4}
			>
				{message ? message : t('Content not available or no data found for this section!')}
			</Typography>
		</Box>
	) : (
		<>
			{children}
		</>
	)
};

export default ContentNotFound